"use client"

import { StatusBadge } from "@/components/ui/status-badge"
import type { ProductHomeCard } from "@/lib/product-home"

import { ProductShelfUiIllustration } from "./product-shelf-ui-illustration"

export function shelfCardField(brandColor: string): string {
  return `color-mix(in oklch, ${brandColor} 10%, var(--card))`
}

export function ShelfCardIllustration({
  card,
  showStage = true,
  embedded,
}: {
  card: ProductHomeCard
  showStage?: boolean
  /** Illustration flush on a brand-tinted card — no nested white window. */
  embedded?: boolean
}) {
  return (
    <div className="relative w-full">
      <div aria-hidden>
        <ProductShelfUiIllustration
          product={card.product}
          brandColor={card.brandColor}
          embedded={embedded}
        />
      </div>
      {showStage && card.stage ? (
        <StatusBadge
          status={card.stage}
          size="sm"
          className="absolute right-2 top-2 z-10 shadow-sm"
        />
      ) : null}
    </div>
  )
}
